/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { PureComponent } from "react";
import { string, node, oneOfType, arrayOf } from "prop-types";
import "./progressbar.scss";

class ProgressBar extends PureComponent {
  render() {
    const progressItems = this.props.partitionItems.map((partitionItem) => (
      <div
        key={partitionItem.id}
        className={`Webcomponents WebcomponentsProgressBar ${partitionItem.name}`}
        style={{ width: +partitionItem.percentage + "%" }}
      />
    ));
    return <div className="progress-completion-bar">{progressItems}</div>;
  }
}

ProgressBar.propTypes = {
  id: string.isRequired,
  children: oneOfType([arrayOf(node), node]),
};

export default ProgressBar;
